import React, { useEffect, useState } from "react";
import axiosInstance from "../components/api/axiosInstance";
import PortalSelect from "./PortalSelect";

function PortalLocationSelects({ countryId, stateId, cityId, onChange }) {
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [loadingCountries, setLoadingCountries] = useState(false);
  const [loadingStates, setLoadingStates] = useState(false);
  const [loadingCities, setLoadingCities] = useState(false);

  useEffect(() => {
    let active = true;
    (async () => {
      setLoadingCountries(true);
      try {
        const res = await axiosInstance.get("/client/countries");
        if (active) {
          setCountries(Array.isArray(res.data?.data) ? res.data.data : []);
        }
      } catch (_) {
        if (active) setCountries([]);
      } finally {
        if (active) setLoadingCountries(false);
      }
    })();
    return () => {
      active = false;
    };
  }, []);

  useEffect(() => {
    if (!countryId) {
      setStates([]);
      return undefined;
    }

    let active = true;
    (async () => {
      setLoadingStates(true);
      try {
        const res = await axiosInstance.get(`/client/states/${countryId}`);
        if (active) {
          setStates(Array.isArray(res.data?.data) ? res.data.data : []);
        }
      } catch (_) {
        if (active) setStates([]);
      } finally {
        if (active) setLoadingStates(false);
      }
    })();
    return () => {
      active = false;
    };
  }, [countryId]);

  useEffect(() => {
    if (!stateId) {
      setCities([]);
      return undefined;
    }

    let active = true;
    (async () => {
      setLoadingCities(true);
      try {
        const res = await axiosInstance.get(`/client/cities/${stateId}`);
        if (active) {
          setCities(Array.isArray(res.data?.data) ? res.data.data : []);
        }
      } catch (_) {
        if (active) setCities([]);
      } finally {
        if (active) setLoadingCities(false);
      }
    })();
    return () => {
      active = false;
    };
  }, [stateId]);

  const handleCountryChange = (e) => {
    const value = e.target.value;
    onChange({
      countryId: value || "",
      stateId: "",
      cityId: "",
    });
  };

  const handleStateChange = (e) => {
    const value = e.target.value;
    onChange({
      countryId,
      stateId: value || "",
      cityId: "",
    });
  };

  const handleCityChange = (e) => {
    onChange({
      countryId,
      stateId,
      cityId: e.target.value || "",
    });
  };

  return (
    <>
      <div className="cportal-field">
        <label>Country</label>
        <PortalSelect value={countryId || ""} onChange={handleCountryChange} disabled={loadingCountries}>
          <option value="">Select Country</option>
          {countries.map((country) => (
            <option key={country.country_id} value={country.country_id}>
              {country.country_name}
            </option>
          ))}
        </PortalSelect>
      </div>
      <div className="cportal-field">
        <label>State</label>
        <PortalSelect
          value={stateId || ""}
          onChange={handleStateChange}
          disabled={!countryId || loadingStates}
        >
          <option value="">Select State</option>
          {states.map((state) => (
            <option key={state.state_id} value={state.state_id}>
              {state.state_name}
            </option>
          ))}
        </PortalSelect>
      </div>
      <div className="cportal-field">
        <label>City</label>
        <PortalSelect
          value={cityId || ""}
          onChange={handleCityChange}
          disabled={!stateId || loadingCities}
        >
          <option value="">Select City</option>
          {cities.map((city) => (
            <option key={city.city_id} value={city.city_id}>
              {city.city_name}
            </option>
          ))}
        </PortalSelect>
      </div>
    </>
  );
}

export default PortalLocationSelects;
